import { render, staticRenderFns } from "./AcademiesSelect.vue?vue&type=template&id=174164ce&scoped=true"
import script from "./AcademiesSelect.vue?vue&type=script&lang=js"
export * from "./AcademiesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174164ce",
  null
  
)

export default component.exports